import { RouteRecordRaw } from 'vue-router';

const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: () => import('@/app/dashboard/components/dashboard-loader.vue'),
    name: 'app.home',
  },
];

export default dashboardRoutes;
